import { Link, NavLink } from "react-router-dom";
import { ChevronDown, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { restaurantInfo } from "../mock";

export const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/menu", label: "Menu" },
  { to: "/drinks-menu", label: "Drinks Menu" },
  { to: "/beverages-menu", label: "Beverages" },
  { to: "/gallery", label: "Gallery" },
  { to: "/reservations", label: "Reservations" },
  { to: "/contact", label: "Contact" }
];


export function NavLogo() {
  return (
    <Link to="/" className="flex items-center gap-2 lg:gap-3 flex-shrink-0">
      {/* Logo Image */}
      <img
        src="/image/logo/logo spice.png"
        alt="Sea Spice Kitchen"
        className="w-10 h-10 xl:w-12 xl:h-12 object-contain"
      />

      <div className="leading-tight">
        <h1 className="text-white text-lg xl:text-xl font-bold whitespace-nowrap">
          Sea Spice Kitchen
        </h1>

        <div className="text-spice-gold text-[9px] xl:text-[10px] tracking-[0.25em] uppercase whitespace-nowrap">
          Coastal Fusion · Frankston
        </div>
      </div>
    </Link>
  );
}
export function DesktopNav() {
  const primaryItems = navItems.filter((item) => !["/drinks-menu", "/beverages-menu"].includes(item.to));

  return (
    <nav className="hidden lg:flex items-center gap-0.5 xl:gap-1 mx-4 xl:mx-6">
      {primaryItems.map((item) => (
        item.to === "/menu" ? (
          <div key={item.to} className="group relative">
            <NavLink
              to={item.to}
              className={({ isActive }) => `relative flex items-center gap-1 px-2 xl:px-3 py-2 text-xs xl:text-sm font-medium tracking-wide transition-colors duration-300 ${isActive ? "text-spice-gold" : "text-white/85 hover:text-spice-gold"}`}
            >
              Menu <ChevronDown size={14} />
            </NavLink>
            <div className="absolute left-0 top-full hidden min-w-44 border border-white/10 bg-[#0d2929] py-2 shadow-xl group-hover:block group-focus-within:block">
              <NavLink to="/menu" className="block px-4 py-2 text-sm text-white/85 hover:bg-white/5 hover:text-spice-gold">Food Menu</NavLink>
              <NavLink to="/drinks-menu" className="block px-4 py-2 text-sm text-white/85 hover:bg-white/5 hover:text-spice-gold">Drinks Menu</NavLink>
              <NavLink to="/beverages-menu" className="block px-4 py-2 text-sm text-white/85 hover:bg-white/5 hover:text-spice-gold">Beverages</NavLink>
            </div>
          </div>
        ) : (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/"}
          className={({ isActive }) =>
            `relative px-2 xl:px-3 py-2 text-xs xl:text-sm font-medium tracking-wide transition-colors duration-300 ${
              isActive ? "text-spice-gold" : "text-white/85 hover:text-spice-gold"
            }`
          }
        >
          {({ isActive }) => (
            <>
              {item.label}
              <span
                className={`absolute left-1/2 -translate-x-1/2 bottom-1 h-px bg-spice-gold transition-all duration-300 ${
                  isActive ? "w-6" : "w-0"
                }`}
              />
            </>
          )}
        </NavLink>
        )
      ))}
    </nav>
  );
}

export function DesktopCTA() {
  return (
    <div className="hidden lg:flex items-center gap-3 flex-shrink-0">
      <a
        href={`tel:${restaurantInfo.phone}`}
        className="hidden xl:flex items-center gap-2 text-white/85 hover:text-spice-gold text-sm whitespace-nowrap transition-colors"
      >
        <Phone size={14} />
        {restaurantInfo.phoneDisplay}
      </a>
      <Link to="/reservations">
        <Button className="bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold tracking-wide rounded-none px-4 xl:px-6 h-11 whitespace-nowrap">
          Book a Table
        </Button>
      </Link>
    </div>
  );
}

export function MobileMenu({ open }) {
  return (
    <div
      className={`lg:hidden bg-[#0d2929] overflow-hidden transition-all duration-500 ${
        open ? "max-h-[600px] border-t border-white/10" : "max-h-0"
      }`}
    >
      <nav className="flex flex-col px-6 py-6 gap-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `py-3 px-3 text-base font-medium border-b border-white/5 ${
                isActive ? "text-spice-gold" : "text-white/85"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
        <Link to="/reservations" className="mt-4">
          <Button className="w-full bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold rounded-none h-12">
            Book a Table
          </Button>
        </Link>
        <a
          href={`tel:${restaurantInfo.phone}`}
          className="mt-3 flex items-center justify-center gap-2 text-white/85 text-sm"
        >
          <Phone size={14} />
          {restaurantInfo.phoneDisplay}
        </a>
      </nav>
    </div>
  );
}
